class MultimediaSearch extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            form: ".js-multimedia-search-form",
            wrap: ".js-multimedia-search-wrap",
            grid: ".js-grid",
            article: ".js-article",
            loadMore: ".js-load-more"
        };
        this.form = document.querySelector(this.selectors.form);
        this.wrap = this.querySelector(this.selectors.wrap);
        this.dataSection = this.getAttribute('data-section');
        this.url = '';
        this.init();
    }

    initLoadMore() {
        this.loadMore = this.querySelector(this.selectors.loadMore);
        if (this.loadMore != null) {
            this.loadMore.addEventListener('click', () => {
                this.getHtmlLoadMore(`${this.url}&page=${this.loadMore.getAttribute('data-next')}`);
            });
        }
    }

    checkLoadMore(html) {
        const newLoadMore = html.querySelector(this.selectors.loadMore);
        if (newLoadMore != null) {
            this.loadMore.classList.add('is-visible');
            this.loadMore.setAttribute('data-next', newLoadMore.getAttribute('data-next'));
        } else {
            this.loadMore.classList.remove('is-visible');
        }
    }

    getHtml(url) {
        this.wrap.classList.add('is-loading');
        this.url = url;
        fetch(url).then((response) => {
            return response.json();
        }).then((state) => {
            const html = new DOMParser().parseFromString(state[this.dataSection], 'text/html');
            this.wrap.innerHTML = html.querySelector(this.selectors.wrap).innerHTML;
            this.wrap.classList.remove('is-loading');
            document.querySelector('.multimedia__nav-item.is-active')?.classList.remove('is-active');
            this.grid = document.querySelector(this.selectors.grid);
            setTimeout(() => {
                this.querySelectorAll(this.selectors.article).forEach((el, index) => {
                    el.classList.remove('is-hidden');
                });
            }, 10)
            this.initLoadMore();

        }).catch((error) => {
            this.wrap.classList.remove('is-loading')
        });
    }

    getHtmlLoadMore(url) {
        fetch(url).then((response) => {
            return response.json();
        })
            .then((state) => {
                const html = new DOMParser().parseFromString(state[this.dataSection], 'text/html');
                html.querySelectorAll(this.selectors.article).forEach((el) => {
                    this.grid.append(el);
                });
                setTimeout(() => {
                    this.querySelectorAll(this.selectors.article).forEach((el, index) => {
                        el.classList.remove('is-hidden');
                    });
                }, 10)

                this.checkLoadMore(html);
            })
            .catch((error) => {
                this.style.display = "none";
            });
    }

    init() {
        this.form.addEventListener('submit', e => {
            e.preventDefault();
            let formData = new FormData(this.form);

            let search = new URLSearchParams(formData);
            let queryString = search.toString();
            this.getHtml(`${this.form.getAttribute('action')}?${queryString}`);

        })
    }
}

export default MultimediaSearch;
